import { render, staticRenderFns } from "./OrderStatusAutoComplete.vue?vue&type=template&id=336e8ac8&"
import script from "./OrderStatusAutoComplete.vue?vue&type=script&lang=js&"
export * from "./OrderStatusAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
